export * from './AccordionBlock';

import { AccordionBlock } from './AccordionBlock';

export default AccordionBlock;
